angular.module('unica_notification_template.notification_template_controllers')

.controller('NotificationTemplateCreateController', function(
	$rootScope, $scope, $state, $stateParams,
	NotificationTemplateCreateService
) {
	$scope.event_id = $stateParams.event_id;

	$scope.tinymceOptionsReady = false;

	$scope.tinymceOptionsEmailSubjectNotification = angular.copy($rootScope.tinymceOptionsEmailSubject);
	$scope.tinymceOptionsEmailBodyNotification = angular.copy($rootScope.tinymceOptionsEmailBody);

	$scope.attachmentTags = [];

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getEventTags( $stateParams.event_id );

	$scope.$on( 'event_tag_loaded', function() {
		// console.log('test');
		

		var tinymceValues = [
			{ text: 'Nome', value: '{FIRST_NAME}' },
			{ text: 'Cognome', value: '{LAST_NAME}' }
		];

		angular.forEach($rootScope.eventTagData, function(tag, key) {
			if ( tag.type === 'text' ) {
				var value = tag.tag.toLowerCase();
				value = value.replace(' ', '_');
				value = value.replace('à', 'a');
				value = value.replace('è', 'e');
				value = value.replace('é', 'e');
				value = value.replace('ì', 'i');
				value = value.replace('ò', 'o');
				value = value.replace('ù', 'u');
				value = value.replace(/[^a-zA-Z0-9]/g, '_');
				value = value.toUpperCase();

				tinymceValues.push({text: tag.tag, value: '{' + value + '}'});
			} else if ( tag.type === 'attachment' ) {
				$scope.attachmentTags.push( {text: tag.tag, value: 'tag_' + tag.id, state: false } );
				console.log($scope.attachmentTags);
			}
		});

		$scope.tinymceOptionsEmailSubjectNotification.setup = function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: tinymceValues,
				onPostRender: function () {
				}
			});
		};

		$scope.tinymceOptionsEmailBodyNotification.setup = function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: tinymceValues,
				onPostRender: function () {
				}
			});
		};


		$scope.tinymceOptionsReady = true;

	});

	$rootScope.getServicesUsers();

	$scope.resetNotificationTemplateData();

	$scope.saveNotificationTemplate = function()
	{
		$scope.showLoader();

		var notificationTemplateData = angular.copy($scope.notificationTemplateData);

		// notificationTemplateData.attachmentTags = [];

		// angular.forEach($scope.attachmentTags, function(attachmentTag, key) {
		// 	if ( attachmentTag.state ) {
		// 		notificationTemplateData.attachmentTags.push(attachmentTag.id);
		// 	}
		// });


		NotificationTemplateCreateService
			.create( $stateParams.event_id, notificationTemplateData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Template Notifica creato con successo!', '');

					$state.go('app.notification_template.edit', { event_id: $stateParams.event_id, id: data.id });
				}
			});
	};

});


